/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoModelsThreadColor
 */
export interface FusionMelcoModelsThreadColor {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsThreadColor
     */
    argb?: string | null;
}

export function FusionMelcoModelsThreadColorFromJSON(json: any): FusionMelcoModelsThreadColor {
    return FusionMelcoModelsThreadColorFromJSONTyped(json, false);
}

export function FusionMelcoModelsThreadColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoModelsThreadColor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'argb': !exists(json, 'argb') ? undefined : json['argb'],
    };
}

export function FusionMelcoModelsThreadColorToJSON(value?: FusionMelcoModelsThreadColor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'argb': value.argb,
    };
}


